/* Navigate to the quiz inside its shadow root and to the subscription section. */
(() => {
  const destinations = new Set(['#find-your-sanctuary', '#sanctuary-coffee-club']);
  const cleanPath = value => value.replace(/\/$/, '') || '/';

  async function reveal(hash) {
    if (!destinations.has(hash)) return;
    if (document.querySelector('#sr-simple-home, .sr-dedicated-quiz, .sr-dedicated-club')) {
      const destination = new URL(location.href);
      destination.searchParams.set('view', hash === '#find-your-sanctuary' ? 'coffee-match' : 'subscriptions');
      destination.hash = '';
      location.replace(destination.pathname + destination.search);
      return;
    }
    let target, heading;
    if (hash === '#find-your-sanctuary') {
      const finder = document.querySelector('sanctuary-coffee-finder');
      if (!finder) return;
      await customElements.whenDefined('sanctuary-coffee-finder');
      target = finder.shadowRoot?.querySelector('#quiz');
      heading = target?.querySelector('h3');
      finder.dispatchEvent(new CustomEvent('sr:finder', { bubbles: true, detail: { type: 'start' } }));
    } else {
      target = document.getElementById('sanctuary-coffee-club');
      heading = target?.querySelector('h2');
    }
    if (!target) return;
    heading?.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
  }

  async function closeDrawer(link, event) {
    const drawer = link.closest('header-drawer');
    const details = drawer?.querySelector('details');
    if (!details?.open) return;
    if (typeof drawer.closeMenuDrawer !== 'function') {
      details.removeAttribute('open');
      return;
    }
    await new Promise(resolve => {
      let timer;
      const finish = () => {
        if (details.open) return;
        clearTimeout(timer);
        details.removeEventListener('toggle', finish);
        resolve();
      };
      details.addEventListener('toggle', finish);
      drawer.closeMenuDrawer(event, details.querySelector('summary'));
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      timer = setTimeout(() => { details.removeEventListener('toggle', finish); resolve(); }, 600);
    });
  }

  document.addEventListener('click', async event => {
    const link = event.target.closest?.('a[href]');
    if (!link || !link.closest('header, .footer') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || cleanPath(url.pathname) !== cleanPath(location.pathname) || !destinations.has(url.hash)) return;
    event.preventDefault();
    await closeDrawer(link, event);
    if (location.hash !== url.hash) history.pushState(null, '', location.pathname + location.search + url.hash);
    await reveal(url.hash);
  });
  window.addEventListener('hashchange', () => reveal(location.hash));
  // Cross-page menu links wait for the page and the quiz component to be ready.
  if (document.readyState === 'complete') reveal(location.hash);
  else window.addEventListener('load', () => reveal(location.hash), { once: true });
})();

